import { HighlightOffOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from '@mui/material';

interface IMetafieldPreferenceDialog {
    showMetafieldsPreferenceDialog: boolean;
    setShowMetafieldsPreferenceDialog: (newState: boolean) => void;
    metafieldSaveMode?: 'saveAsNew' | 'saveAsExisting';
    metafieldName: string;
    setMetafieldName: (newName: string) => void;
    handleSaveMatafieldsPreference: (saveAsOpt: 'saveAsExisting' | 'saveAsNew') => void;
    loading: boolean;
}

export const MetafieldPreferenceDialog = ({
    showMetafieldsPreferenceDialog,
    setShowMetafieldsPreferenceDialog,
    metafieldSaveMode,
    metafieldName,
    setMetafieldName,
    handleSaveMatafieldsPreference,
    loading
}: IMetafieldPreferenceDialog) => (
    <Dialog
        open={showMetafieldsPreferenceDialog}
        onClose={() => setShowMetafieldsPreferenceDialog(false)}
        sx={{ '& .MuiPaper-root': { padding: 0 } }}
        fullWidth
    >
        <DialogTitle component="div" sx={{ paddingX: 1 }}>
            <Grid container alignItems="center">
                <Typography variant="h3" sx={{ flexGrow: 1, marginLeft: '1rem', fontWeight: 500, color: '#37326E' }} fontSize="24px">
                    {`${metafieldSaveMode === 'saveAsNew' ? 'Save as new' : 'Edit'} metafields preference`}
                </Typography>

                <IconButton onClick={() => setShowMetafieldsPreferenceDialog(false)}>
                    <HighlightOffOutlined fontSize="medium" color="secondary" />
                </IconButton>
            </Grid>
        </DialogTitle>
        <DialogContent sx={{ pb: '0 !important', overflow: 'hidden' }}>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs={2}>
                    <Typography>Name:</Typography>
                </Grid>
                <Grid item xs={7}>
                    <TextField
                        variant="filled"
                        value={metafieldName}
                        onChange={(e) => setMetafieldName(e.target.value)}
                        size="small"
                        fullWidth
                        InputProps={{ disableUnderline: true, hiddenLabel: true }}
                        sx={{
                            '& .MuiFilledInput-root': { height: '34px', borderRadius: '10px', py: 0 }
                        }}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button
                disabled={false}
                variant="outlined"
                color="secondary"
                sx={{ p: '12px !important', lineHeight: 1, borderRadius: '8px' }}
                onClick={() => setShowMetafieldsPreferenceDialog(false)}
            >
                Cancel
            </Button>

            <Button
                disabled={loading}
                color="secondary"
                sx={{ p: '12px !important', lineHeight: 1, borderRadius: '8px' }}
                onClick={() => handleSaveMatafieldsPreference('saveAsNew')}
                variant="contained"
            >
                Save
            </Button>
        </DialogActions>
    </Dialog>
);
